var exports = {
  "z": "x620889e6--ad3546--root",
  "p": "x620889e6--ad3546--caption",
};

module.exports = exports;
